import { type ReactNode } from 'react';

import { ConditionallyRender, type ConditionallyRenderProps } from '../util/ConditionallyRender';

import { EmptyMessage, type EmptyMessageProps } from './EmptyMessage';

interface EmptyProps extends EmptyMessageProps, Pick<ConditionallyRenderProps, 'fallback'> {
  readonly isEmpty: boolean | undefined;
  readonly messageContent?: ReactNode;
}

export const Empty = ({ children, fallback, isEmpty, messageContent, ...props }: EmptyProps) => (
  <ConditionallyRender
    fallback={fallback ?? <EmptyMessage {...props}>{messageContent}</EmptyMessage>}
    show={isEmpty !== true}
  >
    {children}
  </ConditionallyRender>
);
